@if (field) {
  <div class="modal fade" id="edit-client-details-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" [hidden]="field !== 'active'">
          <form #editClientActiveForm="ngForm">
            <div class="form-group">
              <label>Status <span class="text-danger small">(required)</span></label>
              <select class="form-control" name="active" [(ngModel)]="client.active" required>
                <option value="" selected disabled>Select status</option>
                <option [value]="true">Active</option>
                <option [value]="false">Inactive</option>
              </select>
            </div>
          </form>
        </div>
        <div class="modal-body" [hidden]="field !== 'driveurl'">
          <form #editClientDriveurlForm="ngForm">
            <label>Google Drive folder <span class="text-danger small">(required)</span></label>
            <input type="url" class="form-control" [ngClass]="setClassInvalidTpl(driveurl)" #driveurl="ngModel" name="driveurl"
              [(ngModel)]="client.driveurl" [pattern]="urlRegexp" placeholder="https://drive.google.com/drive/folders/abc123" required>
            </form>
          </div>
          <div class="modal-body" [hidden]="field !== 'contract'">
            <form #editClientContractForm="ngForm">
              <div class="form-group">
                <label>Contract <span class="text-danger small">(required)</span></label>
                <select class="form-control" name="contract" [(ngModel)]="contract.name" required>
                  <option value="" selected disabled>Select contract</option>
                  @for (contract of contracts; track contract) {
                    <option [value]="contract">{{contract}}</option>
                  }
                </select>
              </div>
              <div class="form-group">
                <label>Start date <span class="text-danger small">(required)</span></label>
                <input type="date" class="form-control" name="startDate" [(ngModel)]="contract.startDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" required>
              </div>
              <div class="form-group">
                <label>End date <span class="text-danger small">(required)</span></label>
                <input type="date" class="form-control" name="endDate" [(ngModel)]="contract.endDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" required>
              </div>
              <div class="form-group">
                <label>Automatic renewal <span class="text-danger small">(required)</span></label>
                <select class="form-control" name="autorenewal" [(ngModel)]="contract.autorenewal" required>
                  <option value="" selected disabled>Select automatic renewal</option>
                  <option [value]="true">Yes</option>
                  <option [value]="false">No</option>
                </select>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Cancellation date (disdetta)</label>
                  <input type="date" class="form-control" name="cancellationDate" [(ngModel)]="contract.cancellationDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD">
                </div>
                <div class="form-group col-md-6">
                  <label>Cancellation days</label>
                  <select class="form-control" name="cancellationDays" [(ngModel)]="contract.cancellationDays" required>
                    <option value="" selected disabled>Select days</option>
                    <option [value]="0">0 days</option>
                    <option [value]="30">30 days</option>
                    <option [value]="60">60 days</option>
                    <option [value]="90">90 days</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-body" [hidden]="field !== 'goal'">
            <form #editClientGoalForm="ngForm">
              <div class="form-group">
                <label>Goal <span class="text-danger small">(required)</span></label>
                <input type="text" class="form-control" name="description" [(ngModel)]="goal.description" placeholder="Goal description" required>
              </div>
              <div class="form-group">
                <label>Due date <span class="text-danger small">(required)</span></label>
                <input type="date" class="form-control" name="dueDate" [(ngModel)]="goal.dueDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" required>
              </div>
              <div class="form-group">
                <label>Achieved <span class="text-danger small">(required)</span></label>
                <select class="form-control" name="achieved" [(ngModel)]="goal.achieved" required>
                  <option value="" selected disabled>Select achieved</option>
                  <option [value]="true">Yes</option>
                  <option [value]="false">No</option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-body" [hidden]="field !== 'notes'">
            <label>Notes</label>
            <textarea class="form-control" name="notes" [(ngModel)]="client.notes" rows="5" placeholder="Notes"></textarea>
          </div>
          <div [hidden]="field !== 'reviews'">
            <div class="modal-body">
              <label>Good</label>
              <textarea class="form-control" [name]="'good_'+reviewYear" [(ngModel)]="client.reviews['good_'+reviewYear]" (blur)="updateClient(field)" rows="5" placeholder="Good items"></textarea>
            </div>
            <div class="modal-body">
              <label>Bad</label>
              <textarea class="form-control" [name]="'bad_'+reviewYear" [(ngModel)]="client.reviews['bad_'+reviewYear]" (blur)="updateClient(field)" rows="5" placeholder="Bad items"></textarea>
            </div>
            <div class="modal-body">
              <label>Discussion</label>
              <textarea class="form-control" [name]="'discussion_'+reviewYear" [(ngModel)]="client.reviews['discussion_'+reviewYear]" (blur)="updateClient(field)" rows="5" placeholder="Discussion"></textarea>
            </div>
          </div>
          <div class="modal-body" [hidden]="field !== 'socials'">
            <form #editClientSocialsForm="ngForm">
              <div class="form-group">
                <label>X</label>
                <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(twitter)" #twitter="ngModel"
                  [(ngModel)]="client.socials.twitter.username" name="twitter" [pattern]="usernameRegexp.twitter" placeholder="mario_rossi">
              </div>
              <div class="form-group">
                <label>Instagram</label>
                <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(instagram)" #instagram="ngModel"
                  [(ngModel)]="client.socials.instagram.username" name="instagram" [pattern]="usernameRegexp.instagram" placeholder="mario.rossi">
              </div>
              <div class="form-group">
                <label>Facebook</label>
                <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(facebook)" #facebook="ngModel"
                  [(ngModel)]="client.socials.facebook.username" name="facebook" [pattern]="usernameRegexp.facebook" placeholder="MarioRossiOfficial">
              </div>
              <div class="form-group">
                <label>LinkedIn</label>
                <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(linkedin)" #linkedin="ngModel"
                  [(ngModel)]="client.socials.linkedin.username" name="linkedin" [pattern]="usernameRegexp.linkedin" placeholder="mario-rossi">
              </div>
            </form>
          </div>
          <div class="modal-footer">
            @if (field === 'contract') {
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                [disabled]="field === 'contract' && !editClientContractForm.form.valid"
                (click)="updateArrayField('contract')">
                <i class="fa fa-floppy-o"></i> Save
              </button>
            }
            @if (field === 'goal') {
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                [disabled]="field === 'goal' && !editClientGoalForm.form.valid"
                (click)="updateArrayField('goal')">
                <i class="fa fa-floppy-o"></i> Save
              </button>
            }
            @if (field !== 'contract' && field !== 'goal') {
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                [disabled]="(field === 'active' && !editClientActiveForm.form.valid) || (field === 'driveurl' && !editClientDriveurlForm.form.valid) || (field === 'socials' && !editClientSocialsForm.form.valid)"
                (click)="updateClient(field)">
                <i class="fa fa-floppy-o"></i> Save
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }